import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7z"
}), 'KeyboardReturn');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/KeyboardReturn.js
// module id = 4347
// module chunks = 2